import { ApplicationUser } from './ApplicationUser';

export enum UserTaskState {
  CREATED = 'Created',
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
}
export enum UserTaskStateTranslated {
  'Created' = 'user-task-state.created',
  'InProgress' = 'user-task-state.in-progress',
  'Completed' = 'user-task-state.completed',
  'Canceled' = 'user-task-state.canceled',
}
export enum UserTaskAction {
  TASK_COMPLETED = 'Task has been completed',
  TASK_CREATED = 'Task has been created',
  TASK_CANCELED = 'Task has been canceled',
  TASK_STARTED = 'Task has been started',
  TASK_UPDATED = 'Task has been updated',
  RESPONSIBLE_PERSON_CHANGED_TO = 'Responsible person has been changed to {0}',
  STATUS_CHANGED_TO = 'Status has been changed to {0}',
  OPERATION_PERFORMED = '{0} operation has been performed',
  CRUD_PERFORMED = 'CRUD operation has been performed {0}',
}

export enum UserTaskActionTranslated {
  'Task has been completed' = 'user-task-action.task-completed',
  'Task has been created' = 'user-task-action.task-created',
  'Task has been canceled' = 'user-task-action.task-canceled',
  'Task has been started' = 'user-task-action.task-started',
  'Task has been updated' = 'user-task-action.task-updated',
  'Responsible person has been changed to {0}' = 'user-task-action.responsible-person-changed-to',
  'Status has been changed to {0}' = 'user-task-action.status-changed',
  '{0} operation has been performed' = 'user-task-action.operation-performed',
  'CRUD operation has been performed {0}' = 'user-task-action.crud-operation-performed',
}

export interface UserTask {
  id: number;
  companyId: number;
  name: string;
  description: string;
  responsibleUserId: string;
  responsibleUser: ApplicationUser;
  state: UserTaskState;
  createdByUserId: string;
  created: string;
  updatedByUserId: string;
  updated: string;
}
export interface UserTaskFilter {
  filterFrom?: Date | null;
  filterTo?: Date | null;
}
